import { Component, Input, OnInit } from '@angular/core';
import { UnfreezeDirectDebitService } from './unfreeze-direct-debit-popup.service';
import { IUnfreezeDirectDebitRequest } from './interfaces/IUnfreezeDirectDebitResult';
import { IUnfreezeDirectDebitContentsResult } from './interfaces/unfreeze-direct-debit-contents-result.interface';
import { isNullOrUndefined } from 'core-max-lib';
import { ModalService } from 'ClientApp/app/shared/modules/bs-modal/services/modal.service';
import { GtmService } from 'ClientApp/app/shared/cardholders-core/services/gtm.service';
import { UiHelperService } from 'ClientApp/app/shared/cardholders-core/services/ui-helper.service';
import { AppConfigsService } from 'ClientApp/app/config/app-configs.service';
import { IResponse } from 'ClientApp/app/shared/cardholders-core/services/http-service.service';
import { HokHeaderItem } from 'ClientApp/app/modules/direct-debit/interfaces/IGetHokDetailsForAllCard.interface';

@Component({
    selector: 'app-unfreeze-direct-debit-popup',
    templateUrl: './unfreeze-direct-debit-popup.component.html',
    styleUrls: ['./unfreeze-direct-debit-popup.component.scss'],
    providers: [UnfreezeDirectDebitService]
})
export class UnfreezeDirectDebitPopUpComponent implements OnInit {
    @Input() hok: HokHeaderItem;
    showLoader = true;
    step: string;
    infoText: string;
    title: string;
    btnText: string;
    linkText: string;
    showLink = true;
    subTitle: string;
    isGetContents = false;
    isGetData = false;
    contentsResult: IUnfreezeDirectDebitContentsResult;

    constructor(
        private uiHelper: UiHelperService,
        private unfreezeDirectDebitService: UnfreezeDirectDebitService,
        private appConfigsService: AppConfigsService,
        private gtmService: GtmService,
        private modalSrv: ModalService
    ) {}
    ngOnInit(): void {
        this.step = 'active';
        this.unfreezeDirectDebitService
            .getContents()
            .subscribe((res: IResponse<IUnfreezeDirectDebitContentsResult>) => {
                this.isGetContents = true;
                if (res.ReturnCode === 0) {
                    this.contentsResult = res.Result;
                } else {
                    this.gtmService.pusUnfreezeDirectDebit('Technical error', 'Show');
                    this.step = 'error';
                }
                this.showLoader = false;
                this.initPage();
            });
    }
    initPage(): void {
        switch (this.step) {
            case 'active': {
                this.title = this.contentsResult.Title;
                this.infoText =
                    `בלחיצה על כפתור '${this.contentsResult.BtnText}' אנו נשלח לבית העסק ` +
                    (this.hok.merchantName ?? '') +
                    ' בקשה לחדש את חיוב כרטיסך שמסתיים ב ' +
                    (this.hok.sourceCard ?? '');
                this.btnText = this.contentsResult.BtnText;
                this.linkText = this.contentsResult.LinkText;
                break;
            }
            case 'success': {
                this.title = this.contentsResult.SuccessTitle;
                this.subTitle = this.contentsResult.SuccessSubTitle;
                this.infoText = this.contentsResult.SuccessInfoText;
                this.btnText = this.contentsResult.SuccessBtnText;
                this.showLink = false;
                break;
            }
            case 'error': {
                this.title =
                    !isNullOrUndefined(this.contentsResult.ErrorTitle) || this.contentsResult.ErrorTitle === ''
                        ? this.contentsResult.ErrorTitle
                        : 'אופס, נראה שיש תקלה טכנית';
                this.infoText =
                    !isNullOrUndefined(this.contentsResult.ErrorInfoText) || this.contentsResult.ErrorInfoText === ''
                        ? this.contentsResult.ErrorInfoText
                        : 'נסו שוב מאוחר יותר';
                this.btnText =
                    !isNullOrUndefined(this.contentsResult.ErrorBtnText) || this.contentsResult.ErrorBtnText === ''
                        ? this.contentsResult.ErrorBtnText
                        : 'חזרה לפירוט הוראות קבע';
                this.linkText =
                    !isNullOrUndefined(this.contentsResult.ErrorLinkText) || this.contentsResult.ErrorLinkText === ''
                        ? this.contentsResult.ErrorLinkText
                        : 'אני רוצה לנסות שוב';
                break;
            }
            default:
        }
    }

    next(): void {
        switch (this.step) {
            case 'active':
                this.gtmService.pushUnfreezeDirectDebitWorkFlow('Confirmation', 'Confirm', '2');
                this.unfreeze();
                break;
            case 'success':
                this.gtmService.pusUnfreezeDirectDebit('Success', 'Back to direct debit list');
                this.modalSrv.closeModalAndAlertSubscribers();

                break;
            case 'error':
                this.gtmService.pusUnfreezeDirectDebit('Technical error', 'Try again');
                this.unfreeze();
                break;
            default:
                this.modalSrv.closeModalAndAlertSubscribers();

                break;
        }
    }

    nextLink(): void {
        switch (this.step) {
            case 'active':
                this.gtmService.pusUnfreezeDirectDebit('Confirmation', 'Later');
                this.modalSrv.closeModalAndAlertSubscribers();

                break;
            case 'error':
                this.gtmService.pusUnfreezeDirectDebit('Technical error', 'Back to direct debit list');
                this.modalSrv.closeModalAndAlertSubscribers();

                break;
            default:
                this.step = 'active';
                this.initPage();
                break;
        }
    }

    unfreeze(): void {
        const req: IUnfreezeDirectDebitRequest = {
            MerchantName: this.hok.merchantName,
            MerchantID: this.hok.merchantID,
            CardIndex: this.hok.cardIndex,
            ProcessingDate: this.hok.processingDate,
            Acq: this.hok.merchantAcquirer
        };
        this.showLoader = true;
        this.unfreezeDirectDebitService.unfreeze(req).subscribe(
            (res) => {
                this.showLoader = false;
                if (res.returnCode === 0) {
                    this.gtmService.pushUnfreezeDirectDebitWorkFlow('Success', 'Success', '3');
                    this.step = 'success';
                } else {
                    this.gtmService.pusUnfreezeDirectDebit('Technical error', 'Show');
                    this.step = 'error';
                }
                this.initPage();
            },
            (err) => {
                this.modalSrv.closeModal();
            }
        );
    }
}
